import React from 'react'
import moment from 'moment'

function formatDate (date, stamp, format = 'DD [de] MMM') {
  moment.locale('pt-BR', {
    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    monthsParseExact: true
  })
  return moment(date.split('T')[0], stamp).locale('pt-BR').format(format)
}

export default function (propriedades) {
  return (
    <div className='hotels--shows'>
      <a className='event--link' href={`https://reserva.evnts.com.br/${propriedades.urlFriendly}/?idioma=pt-BR`} target='_blank' rel='noopener noreferrer'>''</a>
      <div className='data-evento-newoffice'>
        <h1>{formatDate(propriedades.startDate, 'YYYY-MM-DD')}</h1>
      </div>
      <div className='hotels--info'>
        <h1 className='hotel--shows-title shows-title'>{propriedades.eventName}</h1>
      </div>
    </div>
  )
}
